import "core-js/modules/es6.object.assign";
import { Editor, Error, InfoMessage, Preview, Provider } from '@docpocalypse/code-live';
import cn from 'classnames';
import React, { useState } from 'react';
import { DEFAULT_SHOW_CODE, DEFAULT_SHOW_IMPORTS } from '../config';
import syntaxTheme from '../syntax-theme';

var styles = require('./LiveCode-styles.module.css');

function StyledInfoMessage(props) {
  return /*#__PURE__*/React.createElement(InfoMessage, Object.assign({}, props, {
    className: cn(props.className, styles.info)
  }));
}
/**
 * @public
 */


export default function LiveCode(_ref) {
  var code = _ref.code,
      scope = _ref.scope,
      className = _ref.className,
      titleClassName = _ref.titleClassName,
      contentClassName = _ref.contentClassName,
      editorClassName = _ref.editorClassName,
      previewClassName = _ref.previewClassName,
      resolveImports = _ref.resolveImports,
      language = _ref.language,
      title = _ref.title,
      lineNumbers = _ref.lineNumbers,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? syntaxTheme : _ref$theme,
      _ref$showCode = _ref.showCode,
      showCode = _ref$showCode === void 0 ? DEFAULT_SHOW_CODE : _ref$showCode,
      _ref$showImports = _ref.showImports,
      showImports = _ref$showImports === void 0 ? DEFAULT_SHOW_IMPORTS : _ref$showImports,
      _ref$renderAsComponen = _ref.renderAsComponent,
      renderAsComponent = _ref$renderAsComponen === void 0 ? false : _ref$renderAsComponen;
  var canCollapse = showCode === 'collapsible';

  var _useState = useState(showCode === true),
      expanded = _useState[0],
      setExpanded = _useState[1];

  return /*#__PURE__*/React.createElement(Provider, {
    scope: scope,
    code: code,
    language: language,
    theme: theme,
    showImports: showImports,
    renderAsComponent: renderAsComponent,
    resolveImports: resolveImports
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(className, styles.LiveCode)
  }, title && /*#__PURE__*/React.createElement("div", {
    className: cn(titleClassName, styles.title)
  }, title), /*#__PURE__*/React.createElement("div", {
    className: cn(contentClassName, styles.content)
  }, /*#__PURE__*/React.createElement(Preview, {
    className: cn(previewClassName, styles.preview)
  }), expanded && /*#__PURE__*/React.createElement("div", {
    className: cn(editorClassName, styles.editor)
  }, showCode && /*#__PURE__*/React.createElement(Editor, {
    infoComponent: StyledInfoMessage,
    lineNumbers: lineNumbers
  })), /*#__PURE__*/React.createElement(Error, {
    className: styles.error
  })), !expanded && canCollapse && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles.showCode,
    onClick: function onClick() {
      return setExpanded(function (prev) {
        return !prev;
      });
    }
  }, '</show code>')));
}